import { RadioButtonDesignTokens } from '@primeng/themes/types/radiobutton';

export interface ICustomRadioButtonDesignTokens extends RadioButtonDesignTokens {
  root: RadioButtonDesignTokens['root'] & {
    hoverRing?: {
      width?: string;
      offset?: string;
      color?: string;
    };
  };
  icon: RadioButtonDesignTokens['icon'] & {
    lg: {
      size: string;
    };
  };
}

export const baseRadioToken: ICustomRadioButtonDesignTokens = {
  root: {
    width: '1rem',
    height: '1rem',
    background: '{form.field.background}',
    borderColor: '{form.field.border.color}',
    hoverBorderColor: '{form.field.hover.border.color}',
    checkedHoverBorderColor: '{primary.hover.color}',
    shadow: '{form.field.shadow}',
    hoverRing: {
      color: '{primary.100}',
      offset: '2px',
      width: '1px',
    },
  },
  icon: {
    size: '0.5rem',
    checkedColor: '{primary.contrast.color}',
    checkedHoverColor: '{primary.contrast.color}',
    lg: {
      size: '1rem',
    },
  },
  css: ({ dt }: { dt: (token: string, val?: string) => string }) => `
    .p-radiobutton-checked .p-radiobutton-box .p-radiobutton-icon {
      -webkit-mask: url('/icons/icon-checkmark-correct.svg') no-repeat center;
      mask: url('/icons/icon-checkmark-correct.svg') no-repeat center;
     }
    
    .p-radiobutton:not(.p-disabled):has(.p-radiobutton-input:hover) .p-radiobutton-box {
      outline: ${dt('radiobutton.hoverRing.width')} solid ${dt('radiobutton.hoverRing.color')};
      outline-offset: ${dt('radiobutton.hoverRing.offset')};
    }
     `,
};
